/**
 * All searchwords needs to be found, but not in the same place.
 * @param needle Text string to be searched for, each word will be searched
 * @param haystack Text string to be searched in
 */
export const searchPredicate = (needle: string, haystack: string): boolean => {
  let startindex = 0;
  const searchwords: string[] = needle.split(/\(|\)| /);
  const context: string = " ".concat(haystack.toLocaleLowerCase()).replace(/[(),\-+']/g, "");

  for (let searchindex = 0; searchindex < searchwords.length; searchindex++) {
    const element = " ".concat(searchwords[searchindex]);
    startindex = context.indexOf(element, startindex);
    if (startindex == -1) {
      return false;
    }
  }
  return true;
};
